(function () {
  var menuBtn = document.querySelector("[data-mn-menu]");
  var nav = document.querySelector("[data-mn-nav]");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", function () {
      var open = nav.hasAttribute("hidden");
      if (open) nav.removeAttribute("hidden");
      else nav.setAttribute("hidden", "");
    });
  }

  var searchBtn = document.querySelector("[data-mn-search-open]");
  var search = document.querySelector("[data-mn-search]");
  if (searchBtn && search) {
    searchBtn.addEventListener("click", function () {
      var open = search.hasAttribute("hidden");
      if (open) {
        search.removeAttribute("hidden");
        var input = search.querySelector("input");
        if (input) input.focus();
      } else {
        search.setAttribute("hidden", "");
      }
    });
  }

  document.querySelectorAll("[data-qty]").forEach(function (root) {
    var input = root.querySelector("input");
    var minus = root.querySelector("[data-qty-minus]");
    var plus = root.querySelector("[data-qty-plus]");
    if (!input) return;
    function set(n) {
      var min = parseInt(input.getAttribute("min") || "0", 10);
      input.value = Math.max(min, n);
    }
    if (minus) minus.addEventListener("click", function () { set(parseInt(input.value || "1", 10) - 1); });
    if (plus) plus.addEventListener("click", function () { set(parseInt(input.value || "1", 10) + 1); });
  });

  document.querySelectorAll("[data-pdp]").forEach(function (pdp) {
    var select = pdp.querySelector("[data-variant-select]");
    var options = pdp.querySelectorAll("[data-option]");
    function selectedOptions() {
      var map = {};
      options.forEach(function (el) {
        if (el.checked) map[el.name] = el.value;
      });
      return Object.keys(map).sort().map(function (k) { return map[k]; }).join(" / ");
    }
    function syncVariant() {
      if (!select) return;
      var wanted = selectedOptions();
      var match = Array.prototype.find.call(select.options, function (opt) {
        return opt.getAttribute("data-options") === wanted;
      });
      if (match) select.value = match.value;
      var first = pdp.querySelector('[data-option][name="option-1"]:checked');
      var flavor = pdp.querySelector("[data-pdp-flavor]");
      if (first && flavor) flavor.textContent = first.value;
      syncPrice();
    }
    options.forEach(function (el) { el.addEventListener("change", syncVariant); });

    var moneyFormat = pdp.getAttribute("data-money-format") || "${{amount}}";
    function money(cents) {
      var amount = (Math.round(cents) / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }
    var qtySelect = pdp.querySelector("[data-qty-select]");
    var tiers = pdp.querySelectorAll("[data-tier-qty]");
    function offFor(qty) {
      var off = 0;
      tiers.forEach(function (t) {
        if (qty >= parseInt(t.getAttribute("data-tier-qty"), 10)) off = parseInt(t.getAttribute("data-tier-off"), 10);
      });
      return off;
    }
    function setText(sel, text) {
      pdp.querySelectorAll(sel).forEach(function (el) { el.textContent = text; });
    }
    var addBtn = pdp.querySelector("[data-pdp-add]");
    function syncAvailability(opt) {
      if (!addBtn) return;
      var available = opt.getAttribute("data-available") !== "false";
      addBtn.disabled = !available;
      var addLabel = addBtn.querySelector("[data-pdp-add-label]");
      var soldLabel = addBtn.querySelector("[data-pdp-soldout-label]");
      if (addLabel) addLabel.hidden = !available;
      if (soldLabel) soldLabel.hidden = available;
    }
    function syncPrice() {
      var opt = select ? select.options[select.selectedIndex] : null;
      if (!opt) return;
      syncAvailability(opt);
      var unit = parseInt(opt.getAttribute("data-cents"), 10);
      var compare = parseInt(opt.getAttribute("data-compare-cents") || "0", 10);
      var base = compare > unit ? compare : unit;
      var qty = qtySelect ? parseInt(qtySelect.value, 10) || 1 : 1;
      var off = offFor(qty);
      var saleUnit = unit - Math.floor(unit * off / 100);
      setText("[data-pdp-sale]", money(saleUnit));
      setText("[data-pdp-price]", money(saleUnit));
      setText("[data-pdp-compare]", money(base));
      setText("[data-pdp-plan-compare]", money(base));
      setText("[data-pdp-save]", "Save " + money((base - saleUnit) * qty));
      setText("[data-pdp-total]", money(saleUnit * qty));
      tiers.forEach(function (t) {
        var tOff = parseInt(t.getAttribute("data-tier-off"), 10);
        t.classList.toggle("is-active", tOff === off);
        t.setAttribute("aria-pressed", tOff === off ? "true" : "false");
        var u = t.querySelector("[data-tier-unit]");
        if (u) u.textContent = money(unit - Math.floor(unit * tOff / 100)) + "/ea";
      });
    }
    tiers.forEach(function (t) {
      t.addEventListener("click", function () {
        if (qtySelect) qtySelect.value = t.getAttribute("data-tier-qty");
        syncPrice();
      });
    });
    function setQty(n) {
      if (!qtySelect) return;
      qtySelect.value = Math.min(99, Math.max(1, n || 1));
      syncPrice();
    }
    pdp.querySelectorAll("[data-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setQty((parseInt(qtySelect.value, 10) || 1) + parseInt(btn.getAttribute("data-step"), 10));
      });
    });
    if (qtySelect) {
      qtySelect.addEventListener("input", syncPrice);
      qtySelect.addEventListener("change", function () { setQty(parseInt(qtySelect.value, 10)); });
    }
    syncPrice();

    var main = pdp.querySelector("[data-pdp-main] img");
    var thumbs = Array.prototype.slice.call(pdp.querySelectorAll("[data-pdp-thumb]"));
    function show(i) {
      if (!thumbs.length) return;
      i = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (b, j) { b.classList.toggle("is-active", j === i); });
      if (main) main.src = thumbs[i].getAttribute("data-pdp-thumb");
      var strip = thumbs[i].parentNode;
      strip.scrollLeft = thumbs[i].offsetLeft - strip.offsetLeft - (strip.clientWidth - thumbs[i].offsetWidth) / 2;
    }
    function current() {
      return Math.max(0, thumbs.findIndex(function (b) { return b.classList.contains("is-active"); }));
    }
    thumbs.forEach(function (btn, i) { btn.addEventListener("click", function () { show(i); }); });
    var prev = pdp.querySelector("[data-pdp-prev]");
    var next = pdp.querySelector("[data-pdp-next]");
    if (prev) prev.addEventListener("click", function () { show(current() - 1); });
    if (next) next.addEventListener("click", function () { show(current() + 1); });
  });

  var previews = document.querySelectorAll("[data-mn-preview]");
  if (previews.length) {
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload === "none") v.preload = "auto";
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { rootMargin: "100px" });
      previews.forEach(function (v) { io.observe(v); });
    }

    var modal = document.createElement("div");
    modal.className = "mn-video-modal";
    modal.setAttribute("hidden", "");
    modal.innerHTML = '<button type="button" class="mn-video-modal__close" aria-label="Close video">\u00d7</button><video controls playsinline></video>';
    document.body.appendChild(modal);
    var modalVideo = modal.querySelector("video");
    function closeVideo() {
      modalVideo.pause();
      modalVideo.removeAttribute("src");
      modalVideo.load();
      modal.setAttribute("hidden", "");
    }
    document.querySelectorAll("[data-mn-video]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var preview = btn.querySelector("video");
        modalVideo.src = btn.getAttribute("data-mn-video");
        modalVideo.poster = preview ? preview.poster : "";
        modal.removeAttribute("hidden");
        var p = modalVideo.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
    modal.querySelector(".mn-video-modal__close").addEventListener("click", closeVideo);
    modal.addEventListener("click", function (e) { if (e.target === modal) closeVideo(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hasAttribute("hidden")) closeVideo();
    });
  }

  var drawer = document.querySelector("[data-cart-drawer]");
  if (drawer) {
    var panel = drawer.querySelector(".mn-drawer__panel");
    var body = drawer.querySelector("[data-cart-body]");
    var foot = drawer.querySelector("[data-cart-foot]");
    var freeShip = parseInt(drawer.getAttribute("data-free-ship") || "4500", 10);
    var cartFormat = document.body.getAttribute("data-money-format") || "${{amount}}";
    var closeTimer;

    var cartMoney = function (cents) {
      var amount = (Math.round(cents) / 100).toFixed(2);
      return cartFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    };
    var esc = function (s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    };
    var sized = function (url, w) {
      if (!url) return "";
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
    };

    var openDrawer = function () {
      clearTimeout(closeTimer);
      drawer.removeAttribute("hidden");
      void drawer.offsetWidth;
      drawer.classList.add("is-open");
      document.documentElement.classList.add("mn-lock");
      panel.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove("is-open");
      document.documentElement.classList.remove("mn-lock");
      closeTimer = setTimeout(function () { drawer.setAttribute("hidden", ""); }, 300);
    };

    var render = function (cart) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute("hidden");
        else el.setAttribute("hidden", "");
      });
      drawer.querySelector("[data-cart-title-count]").textContent = cart.item_count ? "(" + cart.item_count + ")" : "";

      var total = cart.total_price;
      var left = freeShip - total;
      drawer.querySelector("[data-cart-ship-text]").innerHTML = left > 0
        ? "You're <strong>" + cartMoney(left) + "</strong> away from <strong>FREE shipping!</strong>"
        : "Congrats! You've unlocked <strong>FREE shipping!</strong>";
      drawer.querySelector("[data-cart-ship-bar]").style.width = Math.min(100, total / freeShip * 100) + "%";
      drawer.classList.toggle("is-free", left <= 0);

      if (!cart.items.length) {
        body.innerHTML = '<div class="mn-drawer__empty"><p>Your cart is empty</p><a class="mn-btn" href="/collections/all">Shop All</a></div>';
        foot.setAttribute("hidden", "");
        return;
      }
      foot.removeAttribute("hidden");
      body.innerHTML = '<ul class="mn-drawer__list">' + cart.items.map(function (item) {
        var variant = item.product_has_only_default_variant ? "" : '<p class="mn-drawer__variant">' + esc(item.variant_title) + "</p>";
        var was = item.original_line_price > item.final_line_price ? "<s>" + cartMoney(item.original_line_price) + "</s>" : "";
        return '<li class="mn-drawer__item" data-line-key="' + esc(item.key) + '">' +
          '<a class="mn-drawer__img" href="' + esc(item.url) + '"><img src="' + esc(sized(item.image, 200)) + '" alt="' + esc(item.product_title) + '"></a>' +
          '<div class="mn-drawer__info">' +
            '<a class="mn-drawer__name" href="' + esc(item.url) + '">' + esc(item.product_title) + "</a>" + variant +
            '<div class="mn-drawer__row">' +
              '<div class="mn-stepper mn-stepper--sm">' +
                '<button type="button" data-line-step="-1" aria-label="Decrease quantity">\u2212</button>' +
                '<input type="number" min="0" max="99" inputmode="numeric" value="' + item.quantity + '" aria-label="Quantity" data-line-qty>' +
                '<button type="button" data-line-step="1" aria-label="Increase quantity">+</button>' +
              "</div>" +
              '<p class="mn-drawer__price">' + was + "<strong>" + cartMoney(item.final_line_price) + "</strong></p>" +
            "</div>" +
            '<button type="button" class="mn-drawer__remove" data-line-remove>Remove</button>' +
          "</div></li>";
      }).join("") + "</ul>";

      var savings = cart.items.reduce(function (sum, i) { return sum + i.original_line_price; }, 0) - total;
      var savingsRow = drawer.querySelector("[data-cart-savings]");
      if (savings > 0) {
        savingsRow.removeAttribute("hidden");
        drawer.querySelector("[data-cart-savings-value]").textContent = "\u2212" + cartMoney(savings);
      } else {
        savingsRow.setAttribute("hidden", "");
      }
      drawer.querySelector("[data-cart-total]").textContent = cartMoney(total);
    };

    var refresh = function () {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(render);
    };

    var changeLine = function (key, qty) {
      drawer.classList.add("is-busy");
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: Math.max(0, Math.min(99, qty)) })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(refresh)
        .then(function () { drawer.classList.remove("is-busy"); });
    };

    var qtyTimer;
    body.addEventListener("click", function (e) {
      var line = e.target.closest("[data-line-key]");
      if (!line) return;
      var input = line.querySelector("[data-line-qty]");
      var step = e.target.closest("[data-line-step]");
      if (step) {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute("data-line-step"), 10));
        clearTimeout(qtyTimer);
        qtyTimer = setTimeout(function () { changeLine(line.getAttribute("data-line-key"), parseInt(input.value, 10) || 0); }, 250);
      } else if (e.target.closest("[data-line-remove]")) {
        changeLine(line.getAttribute("data-line-key"), 0);
      }
    });
    body.addEventListener("change", function (e) {
      if (!e.target.matches("[data-line-qty]")) return;
      var line = e.target.closest("[data-line-key]");
      changeLine(line.getAttribute("data-line-key"), parseInt(e.target.value, 10) || 0);
    });

    drawer.querySelectorAll("[data-cart-close]").forEach(function (el) { el.addEventListener("click", closeDrawer); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
    });
    document.querySelectorAll("[data-cart-open]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        if (document.body.classList.contains("template-cart")) return;
        e.preventDefault();
        refresh();
        openDrawer();
      });
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"][name="add"]');
        var err = form.querySelector(".mn-pdp__error");
        if (err) err.remove();
        if (btn) btn.classList.add("is-loading");
        fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || "Could not add to cart.");
            return refresh().then(openDrawer);
          })
          .catch(function (error) {
            var msg = document.createElement("p");
            msg.className = "mn-pdp__error";
            msg.textContent = error.message;
            (btn ? btn.parentNode : form).appendChild(msg);
          })
          .then(function () { if (btn) btn.classList.remove("is-loading"); });
      });
    });
  }

  var cartPageForm = document.querySelector(".mn-cart form");
  if (cartPageForm) {
    var cartPageTimer;
    var submitCart = function () {
      clearTimeout(cartPageTimer);
      cartPageTimer = setTimeout(function () { cartPageForm.submit(); }, 400);
    };
    cartPageForm.querySelectorAll("[data-qty] button").forEach(function (b) { b.addEventListener("click", submitCart); });
    cartPageForm.querySelectorAll("[data-qty] input").forEach(function (i) { i.addEventListener("change", submitCart); });
  }
})();
